import React from 'react';
import { CommandBar } from '@fluentui/react/lib/CommandBar';
import { useTranslation } from 'react-i18next';
import { messageService } from '../../../services/messageService';
import { Warehouse } from '../../../types/warehouse';

const CommandBarRight = (props: { formData: Warehouse }) => {
  const { t } = useTranslation();
  const newClick = () => {
    messageService.sendMessage({ isNewWarehouse: true });
    // props.createNew(true);
  };
  const saveFormData = () => {
    messageService.sendMessage({ saveWhFormData: true });
  };
  const cloneWarehouse = () => {
    messageService.sendMessage({ cloneWarehouse: true });
  };


  const getItems = () => {
    return [
      {
        key: 'new',
        text: t('new'),
        iconProps: { iconName: 'Add' },
        onClick: () => {
          newClick();
        },
        disabled: false,
      },
      {
        key: 'clone',
        name: t('clone'),
        disabled: !props.formData?.sequenceId,
        iconProps: { iconName: 'Copy' },
        onClick: () => {
          cloneWarehouse();
        },
      },
      {
        key: 'print',
        name: t('print'),
        disabled: true,
        iconProps: { iconName: 'Print' },
        onClick: () => {
        },
      },
      {
        key: 'save',
        text: t('save'),
        iconProps: { iconName: 'Save' },
        onClick: () => {
          saveFormData();
        },
        disabled: false,
      },
    ];
  };

  return (
    <div>
      <CommandBar
        items={getItems()}
        ariaLabel="Use left and right arrow keys to navigate between commands"
      />
    </div>
  );
};

export default CommandBarRight;
